/* Vault 88 intent popup — quieted 2026-09-15.
   Triggers: desktop exit-intent · mobile 70% scroll. NO dwell timers (they fired
   at 14-28s on every page and cost conversion). Rendered only on index /
   collection / list-collections / cart (server-side gate in theme.liquid).
   Variants: new (2-step email→SMS) · return (3rd+ visit) · cart (cart page,
   desktop exit-intent only) · success. */
(function () {
  'use strict';
  var root = document.getElementById('V88Pop');
  if (!root) return;
  // The drops page runs its own opt-in — the discount popup stands down there.
  if (document.querySelector('[data-v88-dropsoptin]')) return;

  var DAY = 864e5;
  var template = root.getAttribute('data-template') || '';
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  // Visit counting: once per browser session.
  var visits = parseInt(lsGet('v88_visits') || '0', 10);
  if (!ssGet('v88_counted')) {
    visits += 1;
    lsSet('v88_visits', String(visits));
    ssSet('v88_counted', '1');
  }

  var now = Date.now();
  var suppressedUntil = parseInt(lsGet('v88_pop_until') || '0', 10);
  var subscribed = lsGet('v88_subscribed') === '1';
  var shownThisSession = ssGet('v88_pop_shown') === '1';
  var cartCount = 0;
  try {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { cartCount = c.item_count || 0; });
  } catch (e) {}

  function showVariant(name) {
    var panels = root.querySelectorAll('[data-v88-variant]');
    for (var i = 0; i < panels.length; i++) {
      panels[i].hidden = panels[i].getAttribute('data-v88-variant') !== name;
    }
    root.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    ssSet('v88_pop_shown', '1');
    var focusable = root.querySelector('[data-v88-variant]:not([hidden]) input, [data-v88-variant]:not([hidden]) button.v88-pop__copy, [data-v88-variant]:not([hidden]) a.v88-pop__btn');
    if (focusable) { try { focusable.focus({ preventScroll: true }); } catch (e) {} }
  }

  function close(suppressDays) {
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    lsSet('v88_pop_until', String(now + (suppressDays || 14) * DAY));
  }

  /* ---- Two-step email → optional SMS (variant: new) ---- */
  var form = root.querySelector('[data-v88-variant="new"] form');
  var step1 = root.querySelector('[data-v88-step="1"]');
  var step2 = root.querySelector('[data-v88-step="2"]');
  var emailInput = root.querySelector('[data-v88-email]');
  var phoneInput = root.querySelector('[data-v88-phone]');
  var consent = root.querySelector('[data-v88-consent]');
  var errEl = root.querySelector('[data-v88-err]');
  var tagsInput = root.querySelector('[data-v88-tags]');
  var skipBtn = root.querySelector('[data-v88-skip]');
  var baseTags = tagsInput ? tagsInput.value : 'newsletter,popup';
  var onStep2 = false;
  var skipping = false;

  function setErr(msg) {
    if (!errEl) return;
    if (msg) { errEl.textContent = msg; errEl.hidden = false; } else { errEl.hidden = true; }
  }

  if (form && step1 && step2) {
    form.addEventListener('submit', function (e) {
      setErr('');
      var hp = form.querySelector('input[name="v88_website"]');
      if (hp && hp.value) { e.preventDefault(); return; }

      // Step 1 submit = advance to the optional SMS step, not a POST.
      if (!onStep2) {
        if (!emailInput || !emailInput.checkValidity()) return; // let native validation speak
        e.preventDefault();
        onStep2 = true;
        step1.hidden = true;
        step2.hidden = false;
        if (phoneInput) { try { phoneInput.focus({ preventScroll: true }); } catch (err2) {} }
        return;
      }

      // Step 2 submit = the real POST. Phone optional; if present it must be
      // a valid US number WITH the consent box checked (TCPA).
      var e164 = '';
      var rawPhone = (!skipping && phoneInput) ? phoneInput.value.trim() : '';
      if (rawPhone) {
        var digits = rawPhone.replace(/\D/g, '');
        if (digits.length === 11 && digits.charAt(0) === '1') e164 = '+' + digits;
        else if (digits.length === 10) e164 = '+1' + digits;
        if (!e164) {
          e.preventDefault();
          setErr('That number does not look right — use a 10-digit US number or skip.');
          return;
        }
        if (!consent || !consent.checked) {
          e.preventDefault();
          setErr('Check the SMS box to receive texts, or clear the phone field.');
          return;
        }
      }
      if (tagsInput) tagsInput.value = baseTags + (e164 ? ',sms-opt-in,phone:' + e164 : '');
      ssSet('v88_pop_sub', '1');
    });

    if (skipBtn) {
      skipBtn.addEventListener('click', function () {
        skipping = true;
        if (phoneInput) phoneInput.value = '';
        if (consent) consent.checked = false;
        setErr('');
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }
  }

  /* ---- Show logic ---- */
  // Success state after our own newsletter post (page reloads with customer_posted=true).
  if (/customer_posted=true/.test(location.search) || /customer_posted=true/.test(location.hash)) {
    lsSet('v88_subscribed', '1');
    lsSet('v88_shipfree', '1'); // vault88-auto-discount adds SHIPFREE to the cart
    try { sessionStorage.removeItem('v88_auto_codes'); } catch (e) {}
    if (window.v88ApplyCodes) window.v88ApplyCodes();
    lsSet('v88_pop_until', String(now + 60 * DAY));
    if (ssGet('v88_pop_sub') === '1') {
      ssSet('v88_pop_sub', '');
      showVariant('success');
    }
  } else if (now >= suppressedUntil && !shownThisSession) {
    var fired = false;
    function fire() {
      if (fired) return;
      var variant;
      if (template === 'cart') {
        if (cartCount === 0) return; // nothing to save
        variant = 'cart';
      } else if (subscribed) {
        return; // already on the list — browse in peace
      } else if (visits >= 3) {
        variant = 'return';
      } else {
        variant = 'new';
      }
      fired = true;
      showVariant(variant);
    }
    if (window.matchMedia('(pointer: fine)').matches) {
      // Desktop: exit intent only — no timers.
      document.addEventListener('mouseleave', function (e) {
        if (e.clientY <= 0) fire();
      });
    } else if (template !== 'cart') {
      // Mobile: deep engagement only (70% scroll) — no timers, nothing on cart.
      window.addEventListener('scroll', function onScroll() {
        var h = document.documentElement;
        var depth = (h.scrollTop + window.innerHeight) / h.scrollHeight;
        if (depth >= 0.7) { window.removeEventListener('scroll', onScroll); fire(); }
      }, { passive: true });
    }
  }

  // Wire close controls.
  var closers = root.querySelectorAll('[data-v88-close]');
  for (var c = 0; c < closers.length; c++) {
    closers[c].addEventListener('click', function () { close(14); });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close(14);
  });

  // Copy buttons.
  var copies = root.querySelectorAll('[data-v88-copy]');
  for (var k = 0; k < copies.length; k++) {
    copies[k].addEventListener('click', function () {
      var code = this.getAttribute('data-v88-copy');
      var btn = this;
      function done() {
        btn.classList.add('is-copied');
        btn.textContent = 'Copied';
        lsSet('v88_pop_until', String(Date.now() + 30 * DAY));
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else { done(); }
    });
  }
})();
